import {
    STAY,
    FORWARD,
    REVERSE,
    FORWARD_REVERSE,
    BROWNIAN
} from 'constants/scene-algorithms.js';
import {uuid} from 'uuidv4';

/**
 * A scene is a combination of patterns from different
 * sub sequences, that may work well together.
 */
class Scene {
    constructor(name, patterns = []) {
        this.name = name;
        this.id = uuid();

        // the pattern for each sub-sequence in this scene
        // goes here in an array, indexed by the # subsequence
        // instead of the id of the sub sequence
        this.patterns = patterns;

        this.algorithmTypes = [];
        this.durationPercentages = []; 

        for (let i in patterns) {
            // we add an algorithm type for each pattern since they can each have
            // their own algorihtms
            // by default they are STAY algorithms
            this.algorithmTypes.push(STAY);
            this.durationPercentages.push(100);
        }
    }

    deleteSubSequence(number) {
        this.patterns.splice(number, 1);
    }

    getJson() {
        return {
            name: this.name,
            patterns: this.patterns,
            algorithmTypes: this.algorithmTypes,
            durationPercentages: this.durationPercentages
        };
    }
}

export default Scene;
